import * as THREE from "three"
import { useFrame } from "@react-three/fiber"
import { useRef, Suspense } from "react"
import { clampFrac, lerp, pinPosition } from "../util"

import useStore from "../AppStore"
import SmartPhone from "../3d/SmartPhone"
import SmartPhoneInterface from "../3d/SmartPhoneInterface"

export default function ScenePhone(props) {
  
  const groupRef = useRef(null)
  const screen1Ref = useRef(null)
  const screen2Ref = useRef(null)
  
  useFrame(({clock}) => {

    const top = useStore.getState().top
    
    groupRef.current.rotation.y = 6 - top * 0.0006 + Math.sin(clock.elapsedTime * 0.8)*0.1
    groupRef.current.rotation.z = -0.3 + Math.cos(clock.elapsedTime * 0.8)*0.1
    
    const interfaceY = (top <= props.flipAt ? -Math.PI/2 : -Math.PI-Math.PI/2)
    screen1Ref.current.rotation.y = lerp(screen1Ref.current.rotation.y, interfaceY, 0.2)
    screen2Ref.current.rotation.y = lerp(screen2Ref.current.rotation.y, interfaceY+Math.PI, 0.2)

  })
  
  return(
    <group ref={groupRef} scale={[1.4,1.4,1.4]}>

      <SmartPhone rotation={[0,0,0]} />

      <group position={[0,0,0]} ref={screen1Ref}>
        <group position={[0,1.8,.6]} >
          <SmartPhoneInterface size={[2,1]} uv={[0,0.75]} uv2={[.5,0.25]} scale={[2,2,2]} />
        </group>
        
        <group position={[0,0.2,.4]}>
          <SmartPhoneInterface size={[2,2]} uv={[0,0.25]} uv2={[.5,0.5]} scale={[2,2,2]} />
        </group>

        <group position={[0,-1.5,.6]}>
          <SmartPhoneInterface size={[2,1]} uv={[0,0]} uv2={[.5,0.25]} scale={[2,2,2]} />
        </group>
      </group>

      <group position={[0,0,0]} ref={screen2Ref}>
        <group position={[0,0.2,.4]}>
          <SmartPhoneInterface size={[2,2]} uv={[0.5,0.5]} uv2={[.5,0.5]} scale={[2,2,2]} />
        </group>
        <group position={[0,0,.6]} >
          <SmartPhoneInterface size={[2,2]} uv={[0.5,0]} uv2={[.5,0.5]} scale={[2,2,2]} />
        </group>
      </group>

    </group>
  )
}